import * as api from '../apiCallerProxy';
import { aiGenerationApiFactory } from './aiGenerationApiFactory';

export * from './hooks';
export default aiGenerationApiFactory(api);
